import { render } from "./CheckoutCart.vue?vue&type=template&id=54ae1e20"
import script from "./CheckoutCart.vue?vue&type=script&lang=js"
export * from "./CheckoutCart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__